export const ANALYTICS_CATEGORIES = [
  "KHUDDAM_IJTIMA",
  "KHUDDAM_MEMBERSHIP",
  "ATHFAL_IJTIMA",
  "ATHFAL_MEMBERSHIP",
  "HALL",
  "LOCAL_FUND",
  "KHIDMAT_KHALAQ",
  "TRX_FEE",
  "TAX",
];

export const MONTH_OPTIONS = [
  { value: 1, label: "Jan" },
  { value: 2, label: "Feb" },
  { value: 3, label: "Mar" },
  { value: 4, label: "Apr" },
  { value: 5, label: "May" },
  { value: 6, label: "Jun" },
  { value: 7, label: "Jul" },
  { value: 8, label: "Aug" },
  { value: 9, label: "Sep" },
  { value: 10, label: "Oct" },
  { value: 11, label: "Nov" },
  { value: 12, label: "Dec" },
];

export const VIEW_OPTIONS = [
  { value: "trend", label: "Trend" },
  { value: "compare", label: "Compare" },
  { value: "muqami", label: "Muqami Ranking" },
];

export const ALL_CATEGORIES = "ALL";
export const ALL_MUQAMI = "ALL";

export function getKualaLumpurDateParts() {
  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Kuala_Lumpur",
    year: "numeric",
    month: "numeric",
  });
  const parts = formatter.formatToParts(new Date());
  const lookup = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  return {
    currentYear: Number(lookup.year),
    currentMonth: Number(lookup.month),
  };
}

export function formatToken(token = "") {
  return token === "TRX_FEE"
    ? "Transaction Fee"
    : token
        .toLowerCase()
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
}

export function formatCategoryName(name = "") {
  if (name === ALL_CATEGORIES) return "All Categories";
  return name.split(/\s+/).filter(Boolean).map(formatToken).join(" ");
}

export function formatMuqamiName(name = "") {
  if (!name || name === ALL_MUQAMI) return "All Muqami";
  return name
    .toLowerCase()
    .split("_")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function formatCurrency(value) {
  return Number(value ?? 0).toLocaleString("en-MY", {
    style: "currency",
    currency: "MYR",
  });
}

export function formatCompactCurrency(value) {
  return Number(value ?? 0).toLocaleString("en-MY", {
    style: "currency",
    currency: "MYR",
    maximumFractionDigits: 0,
  });
}

export function formatPercent(value) {
  return `${Number(value ?? 0).toFixed(1)}%`;
}

export function sumValues(values = []) {
  return values.reduce((sum, value) => sum + Number(value || 0), 0);
}

export function averageValues(values = []) {
  return values.length ? sumValues(values) / values.length : 0;
}

export function buildYearOptions(
  startYear = 2025,
  currentYear = getKualaLumpurDateParts().currentYear
) {
  const years = [];
  for (let year = currentYear; year >= startYear; year -= 1) {
    years.push(year);
  }
  return years;
}

export function clamp(value, min, max) {
  return Math.max(min, Math.min(value, max));
}
